import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import HowItWorks from "@/components/HowItWorks";
import About from "@/components/About";
import ServiceArea from "@/components/ServiceArea";
import Reviews from "@/components/Reviews";
import FAQ from "@/components/FAQ";
import BookingForm from "@/components/BookingForm";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";

const Landing = () => {
  return (
    <div className="min-h-screen bg-white text-brand-black">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <WhyChooseUs />
        <HowItWorks />
        <About />
        <ServiceArea />
        <Reviews />
        <FAQ />
        <BookingForm />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
};

export default Landing;
